import httpClient, { baseURL } from 'utils/httpClient'

export const getRateTypes = async () => {
  const { data } = await httpClient.get('/api/proposals/rate_types')
  return data
}

export const getCarrierProposal = async (
  linkUUID: string,
  accepted: boolean
) => {
  const url = new URL(`${baseURL}/api/proposals/${linkUUID}/`)
  if (accepted) {
    url.searchParams.set('accepted', 'true')
  }
  const { data } = await httpClient.get(url.toString())
  return data
}

export const submitCarrierInvite = async (
  linkUUID: string,
  rateType?: string
) => {
  const payload = { rate_type: rateType }
  return await httpClient.post(`/api/proposals/${linkUUID}/submit/`, payload)
}

export const createLaneProposal = async (
  linkUUID: string,
  lane: LaneProposal
) => {
  const { data } = await httpClient.post(
    `/api/proposals/${linkUUID}/lane_proposals/`,
    lane
  )
  return data
}

export const updateLaneProposal = async (
  linkUUID: string,
  data: LaneProposal
) => {
  return httpClient.put(
    `/api/proposals/${linkUUID}/lane_proposals/${data.id}`,
    data
  )
}

export const destroyLaneProposal = async (
  linkUUID: string,
  data: LaneProposal
) => {
  return httpClient.delete(
    `/api/proposals/${linkUUID}/lane_proposals/${data.id}`
  )
}
